var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4524_4392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6001 0.257812C4.18887 0.257812 0.600098 3.84659 0.600098 8.25781C0.600098 12.669 4.18887 16.2577 8.6001 16.2577C13.0113 16.2577 16.6001 12.669 16.6001 8.25781C16.6001 3.84667 13.0112 0.257812 8.6001 0.257812ZM12.6367 7.36233L11.056 8.90317L11.4292 11.0788C11.4482 11.1897 11.4357 11.3037 11.3933 11.408C11.3509 11.5122 11.2802 11.6025 11.1891 11.6686C11.0981 11.7347 10.9904 11.7741 10.8781 11.7823C10.7659 11.7904 10.6536 11.767 10.554 11.7147L8.60018 10.6875L6.64626 11.7148C6.54665 11.7672 6.43434 11.7907 6.32205 11.7826C6.20977 11.7745 6.10199 11.7352 6.01091 11.669C5.91983 11.6028 5.8491 11.5125 5.80671 11.4082C5.76432 11.3039 5.75196 11.1898 5.77105 11.0789L6.14423 8.90325L4.56342 7.36233C4.48284 7.28375 4.42584 7.1842 4.39888 7.07493C4.37193 6.96565 4.37608 6.85101 4.41087 6.74397C4.44566 6.63694 4.50971 6.54177 4.59577 6.46923C4.68182 6.39669 4.78646 6.34967 4.89784 6.3335L7.08226 6.01605L8.05914 4.03656C8.10897 3.93563 8.18603 3.85065 8.28163 3.79123C8.37723 3.73182 8.48754 3.70033 8.6001 3.70033C8.71266 3.70033 8.82297 3.73182 8.91856 3.79123C9.01416 3.85065 9.09123 3.93563 9.14106 4.03656L10.1179 6.01605L12.3024 6.3335C12.4137 6.34968 12.5184 6.39671 12.6044 6.46925C12.6904 6.5418 12.7545 6.63697 12.7893 6.744C12.8241 6.85104 12.8282 6.96567 12.8012 7.07494C12.7743 7.18421 12.7173 7.28376 12.6367 7.36233Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4524_4392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.600098 0.257812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.8f7d00c560240a473a070a520feca331.svg";
export { ForwardRef as ReactComponent };